




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import OzIcon from 'library/v4/components/oz-icon.vue'

@Component({
  components: { OzIcon },
})
export default class SurfacePostCommentsIcon extends Vue {
  @Prop() commentIds!: [string | number]
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop() disable!: boolean

  get commentsListLength(): number {
    return this.commentIds.length
  }

  showCommentsPanel(): void {
    if (this.disable) return
    if (this.$el.closest('.surface-post')?.classList.contains('noclick')) {
      // Prevent popping out the comment panel when the post is being dragged
      return
    }
    this.$emit('show-comments-panel')
  }
}
